// extracted by mini-css-extract-plugin
export default {"dialogTitle":"DeleteChart_dialogTitle__sxbAw","textHead":"DeleteChart_textHead__KYiZa","dialogBtns":"DeleteChart_dialogBtns__QNRCv","deleteBtn":"DeleteChart_deleteBtn__VBsWz"};